
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[church.url]",
      function () {
        return require("private-next-pages/[church.url]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[church.url]"])
      });
    }
  